import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CompanyFormHeader = ({ isEditMode, companyName }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-surface border-b border-border px-6 py-4">
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate('/admin-dashboard')}
            iconName="ArrowLeft"
            iconPosition="left"
            iconSize={16}
          >
            Back to Dashboard
          </Button>
          <div className="h-6 w-px bg-border" />
          <div>
            <h1 className="text-2xl font-semibold text-text-primary">
              {isEditMode ? `Edit Company: ${companyName}` : 'Create New Company'}
            </h1>
            <p className="text-sm text-text-secondary mt-1">
              {isEditMode 
                ? 'Update company configuration and branding settings' :'Configure a new epoxy company with custom branding and settings'}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Building2" size={24} className="text-primary" />
        </div>
      </div>
    </div>
  );
};

export default CompanyFormHeader;